import { render } from "./newClientConfirm.vue?vue&type=template&id=6c4528b4&ts=true"
import script from "./newClientConfirm.vue?vue&type=script&lang=ts&config=true"
export * from "./newClientConfirm.vue?vue&type=script&lang=ts&config=true"

import "./newClientConfirm.vue?vue&type=style&index=0&id=6c4528b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__